module.exports = __webpack_public_path__ + "media/images/pokerroom/pokerstars/step4-pict02-ed5c0204543bb1e1b739bcce93a7afea.jpg";